/* eslint-disable no-debugger */
import api from '~/config/api'
import { baseChargeIntegrations } from '~/config/basePath'

import {
  NegotiationInterface,
  NegotiationTypeInterface,
  RenegotiationEffectuationInputInterface,
  RenegotiationEffectuationOutputInterface,
  RenegotiationSimulationParamsInterface,
  RenegotiationSimulationOutputInterface,
} from '~/models/interfaces/services/Negotiations'

const pathUrl = `${baseChargeIntegrations}/v1/negotiation-portal`
const pathNegotiationsPortal = `${pathUrl}/negotiations`

const getNegotiationsByCustomer = (
  customerId: string,
  cpfCnpj: string,
  idEntryAutomation?: number
): Promise<NegotiationInterface[]> => {
  const params = { customerId, cpfCnpj, idEntryAutomation }

  return api
    .get<NegotiationInterface[]>(`${pathNegotiationsPortal}`, { params })
    .then(({ data }) => data)
}

const getNegotiationsTypesByCustomer = async (
  customerId: string
): Promise<NegotiationTypeInterface[]> =>
  api
    .get<NegotiationTypeInterface[]>(`${pathUrl}/customers/${customerId}/payment-negotiations`)
    .then(({ data }) => data)

const simulate = (
  params: RenegotiationSimulationParamsInterface
): Promise<RenegotiationSimulationOutputInterface> =>
  api
    .post<RenegotiationSimulationOutputInterface>(`${pathNegotiationsPortal}/simulation`, null, {
      params,
    })
    .then(({ data }) => data)

const effectuate = (
  input: RenegotiationEffectuationInputInterface
): Promise<RenegotiationEffectuationOutputInterface> =>
  api
    .post<RenegotiationEffectuationOutputInterface>(`${pathNegotiationsPortal}/effectuation`, input)
    .then(({ data }) => data)

export { getNegotiationsByCustomer, getNegotiationsTypesByCustomer, simulate, effectuate }
